import { render } from "./Pending.vue?vue&type=template&id=30487e3e&ts=true"
import script from "./Pending.vue?vue&type=script&lang=ts"
export * from "./Pending.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__